import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ToastMessage } from '../models/interface/toastMessage.interface';

@Injectable({
  providedIn: 'root',
})
export class MuToastService {
  public toasterCustomClass: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private translateService: TranslateService, private messageService: MessageService) {
    /** */
  }

  /**
   * method to show specific toast
   * @param {Error} exception error cause
   * @param {string} key Identifier for toast
   * @param {string} severity Toast type
   * @param {string} summary Toast title
   * @param {string} detail Toast description
   * @param {number} life Toast duration time
   * @param {object} params? Params to render in language key
   * @param {boolean} sticky? Params to mantain toast
   * @param {object} data? Pass info to toast
   *
   */
  showSpecificToast({ key, severity, summary, detail, life, params, exception, styleClass, sticky, data }: ToastMessage): void {
    if (exception && !environment.production) {
      console.error(exception);
    }
    summary = summary ? this.translateService.instant(summary, params) : '';
    detail = this.translateService.instant(detail, params);
    this.toasterCustomClass.next(styleClass);

    this.messageService.add({
      key: key || 'toast-layout',
      severity,
      summary,
      detail,
      life: life || environment.toastData.life,
      sticky,
      data,
    });
  }

  /**
   * method to clear a list of keys toasts
   * @param {string[]} keyList
   */
  clear(keyList: string[]): void {
    for (const key of keyList) {
      this.messageService.clear(key);
    }
  }
}
